/** Presentation logic for match suggestions — pure so the flashcard's
 *  suggestion flow is unit-testable without the API layer. */

export interface SuggestionFactors {
  amount_exact: boolean;
  date_delta_days: number | null;
  name_similarity: number;
}

/** Human-readable per-factor reasons, in scoring-weight order:
 *  "amount ✓ · date ±2d · name 91%". Factors with no signal are
 *  omitted rather than shown as zeros — the row stays scannable. */
export function matchReasons(s: SuggestionFactors): string[] {
  const reasons: string[] = [];
  if (s.amount_exact) reasons.push('amount ✓');
  if (s.date_delta_days !== null) reasons.push(`date ±${s.date_delta_days}d`);
  if (s.name_similarity > 0) reasons.push(`name ${Math.round(s.name_similarity * 100)}%`);
  return reasons;
}

/** Map a keydown to a suggestion index: "1"–"9" → 0-based index into
 *  the visible list, null for anything else or out of range. */
export function suggestionIndexForKey(key: string, count: number): number | null {
  if (!/^[1-9]$/.test(key)) return null;
  const index = Number(key) - 1;
  return index < count ? index : null;
}
